import { Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { Table } from 'primeng/table';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { TwSeriLogItemViewModel, TwSeriLogItemResultsViewModel } from '../serilog.types';
import { Router } from '@angular/router';

@Component({
    selector: 'app-serilog-list',
    templateUrl: './serilog-list.component.html',
})
export class SeriLogListComponent extends ListBase implements OnInit, OnChanges {
    @Input() result: TwSeriLogItemResultsViewModel;
    @Input() lastFilter: FilterSearchingBaseViewModel;
    @Output() search = new EventEmitter<FilterSearchingBaseViewModel>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    constructor(
        protected notificationService: NotificationService,
        private router: Router,
    ) {
        super(notificationService);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        const twSeriLogVM = proxiedPropertiesOf<TwSeriLogItemViewModel>();

        this.cols = [
            { field: 'Link', header: '' },
            { field: twSeriLogVM.Message?.toString(), header: 'Mensaje' },
            { field: twSeriLogVM.MessageTemplate?.toString(), header: 'Plantilla del mensaje' },
            { field: twSeriLogVM.Level?.toString(), header: 'Nivel' },
            { field: twSeriLogVM.TimeStamp?.toString(), header: 'Registro temporal' },
            { field: twSeriLogVM.Exception?.toString(), header: 'Excepción' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = { ...changes.result.currentValue };
            this.loading = false;
            setTimeout(() => {
                if (this.turboTable) {
                    this.turboTable.sortOrder = this.lastFilter?.Asc;
                    this.turboTable.sortField = this.lastFilter?.OrderBy;
                    this.turboTable.first = this.lastFilter.PageNumber * this.result.PageSize; // i.e. página 4 * 15 elementos x página
                }
            }, 100);
        }
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.loading = true;

        const f: FilterSearchingBaseViewModel = {
            PageNumber: pageNumber,
            Asc: event.sortOrder,
            OrderBy: event.sortField,
        };

        this.search.emit(f);
    }

    onView(item: TwSeriLogItemViewModel) {
        this.router.navigate(['/mantenimiento/envios/serilog/edit', item.Id]);
    }
}
